import { useState } from "react";
import { MIN_USERNAME_LEN } from "@truewave/protocol";
import { useSession } from "../state/session.js";

export function Onboarding() {
  const register = useSession((s) => s.register);
  const error = useSession((s) => s.error);
  const [username, setUsername] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [confirm, setConfirm] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);

  const usernameOk = /^[a-z0-9_]+$/.test(username) && username.length >= MIN_USERNAME_LEN;
  const passOk = passphrase.length >= 8 && passphrase === confirm;

  async function submit() {
    setBusy(true);
    try {
      await register(username, passphrase, inviteCode || undefined);
    } catch {
      /* error surfaced via store */
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center">
      <div className="card">
        <h1>Create your TrueWave account</h1>

        <label>
          Username
          <input
            value={username}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            placeholder="e.g. river_stone"
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
          />
        </label>

        <label>
          Passphrase
          <input
            type="password"
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
            placeholder="at least 8 characters"
          />
        </label>
        <label>
          Confirm passphrase
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </label>

        <label>
          Invite code
          <input
            value={inviteCode}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            placeholder="leave blank unless you were given one"
            onChange={(e) => setInviteCode(e.target.value)}
          />
        </label>

        <div className="banner">
          There is no account recovery. If you forget this passphrase or clear this
          browser's storage, the account and all history are gone for good.
          <label style={{ display: "flex", gap: 8, marginTop: 8, color: "var(--text)" }}>
            <input
              type="checkbox"
              style={{ width: "auto" }}
              checked={acknowledged}
              onChange={(e) => setAcknowledged(e.target.checked)}
            />
            I understand
          </label>
        </div>

        {error && <div className="error">{error}</div>}

        <button
          className="primary"
          disabled={busy || !usernameOk || !passOk || !acknowledged}
          onClick={submit}
        >
          {busy ? "Creating…" : "Create account"}
        </button>
      </div>
    </div>
  );
}
